import React from 'react';
import './Footer.css';
import Facebook from '../assets/Facebook.png';
import Instagram from '../assets/Instagram.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className='footer-img'>
        <img src={Facebook} alt="Facebook" />
        <img src={Instagram} alt="Instagram" />
        </div>
        <p>&copy; 2026 Cozobi Agro. Todos los derechos reservados.</p>
        <div className='pageInfo'>
        <p>
          Ubicacion: <br /> 
          Hermosillo, Sonora
        </p>
        <p>
          Correo:  <br /> 
          cozobi.agro@gmail.com
        </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;